import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {AmplitudePageLocation} from "../../promotion/tracking/OfferPageAmplitudeItemListTrackingContext";

interface ITrackAmplitudeAddToFavouritesParams {
    itemId: number;
    propertyId: number;
    location: AmplitudePageLocation;
}

export const trackAmplitudeAddToFavourites = ({itemId, propertyId, location}: ITrackAmplitudeAddToFavouritesParams): void => {
    trackAmplitudeEvent("add_to_favourites", {
        item_id: itemId,
        property_id: propertyId,
        location
    });
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {AmplitudePageLocation} from "../../promotion/tracking/OfferPageAmplitudeItemListTrackingContext";

interface ITrackAmplitudeAddToFavouritesParams {
    itemId: number;
    propertyId: number;
    location: AmplitudePageLocation;
}

export const trackAmplitudeAddToFavourites = ({itemId, propertyId, location}: ITrackAmplitudeAddToFavouritesParams): void => {
    trackAmplitudeEvent("add_to_favourites", {
        item_id: itemId,
        property_id: propertyId,
        location
    });
};
